export default [
    {
        path: '/incomes-sheet-and-report',
        component: () => import('@/components/DashboardHeaderV2.vue'),
        children: [
            {
                path: '/incomes-sheet-and-report',
                name: 'incomes-sheet-and-report',
                component: () => import('./DashSheetAndReport.vue'),
            }
        ]
    }
]